import { LeafSelectOption } from "./select-option.component.js";
customElements.define("leaf-select-option", LeafSelectOption);
export {
  LeafSelectOption
};
//# sourceMappingURL=select-option.js.map
